import React from 'react';
import type { FollowupStats } from './types';

export function StatsCards({ stats }: { stats: FollowupStats }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      <StatCard value={stats.total_pending} label="Total Pending" />
      <StatCard
        value={stats.overdue}
        label="Overdue"
        emphasize={stats.overdue > 0}
      />
      <StatCard
        value={stats.due_this_week}
        label="Due This Week"
        valueClassName="text-orange-600"
      />
      <StatCard
        value={stats.urgent_priority}
        label="Urgent"
        valueClassName="text-fuchsia-700"
      />
      <StatCard
        value={stats.high_priority}
        label="High Priority"
        valueClassName="text-red-600"
      />
    </div>
  );
}

function StatCard({
  value,
  label,
  emphasize = false,
  valueClassName = 'text-gray-900',
}: {
  value: number;
  label: string;
  emphasize?: boolean;
  valueClassName?: string;
}) {
  return (
    <div
      className={`p-4 rounded-xl border-2 shadow-sm ${
        emphasize
          ? 'bg-red-50 border-red-200'
          : 'bg-white border-gray-200'
      }`}
    >
      <div
        className={`text-2xl md:text-3xl font-black ${
          emphasize ? 'text-red-600' : valueClassName
        }`}
      >
        {value}
      </div>
      <div
        className={`text-xs md:text-sm ${
          emphasize ? 'text-red-600' : 'text-gray-600'
        }`}
      >
        {label}
      </div>
    </div>
  );
}
